import posthog from 'posthog-js';

// El autocapture agotaba la cuota mensual del proyecto PostHog y provocaba
// el descarte de los eventos intencionales (TAN-9354).
export const POSTHOG_OPTIONS = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  autocapture: false,
};

export const ANALYTICS_EVENT = {
  DUPLICATE_SESSION_DETECTED: 'BACKOFFICE DUPLICATE SESSION DETECTED',
  DUPLICATE_SESSION_RESOLVED: 'BACKOFFICE DUPLICATE SESSION RESOLVED',
  SESSION_REVOKED: 'BACKOFFICE SESSION REVOKED',
};

export const DUPLICATE_SESSION_ACTION = {
  CANCEL: 'cancel',
  FORCE_LOGIN: 'force_login',
};

export function trackEvent(event, properties, options) {
  try {
    // environment va al final: es lo que separa los dashboards por entorno y ningun
    // caller debe poder sobrescribirlo.
    posthog.capture(event, { ...properties, environment: process.env.REACT_APP_ENVIRONMENT }, options);
  } catch (error) {
    console.warn('trackEvent: no se pudo capturar el evento de PostHog', error);
  }
}

// El interceptor redirige con window.location.href acto seguido: send_instantly saca el
// evento de la cola de batching (que esperaria segundos) y el fetch con keepalive de
// PostHog es lo que lo hace sobrevivir al unload.
export function trackEventBeforeUnload(event, properties) {
  trackEvent(event, properties, { send_instantly: true });
}
